/* componentName: wmx-cloudsaver
 *  React JS Component
 * =====================
 * 
 * Author: Farhadur Rahim
 * Version: 1.0.0
 * @Licence: http://codecanyon.net/wiki/support/legal-terms/licensing-terms/
 */
import React from 'react';

/**
 * Defined cloud button components for Google Drive
 * 
 * @param {object} props 
 * @returns
 */
const DriveButton = (props) => {
  const driveButton = props.enable ? <button className="g-savetodrive" data-src={props.file} data-filename={props.filename} data-sitename={props.sitename}></button> : '';
  
  return (
      <React.StrictMode>
        {driveButton}
      </React.StrictMode>
    );
}


/**
 * Defined cloud button components for Dropbox
 * 
 * @param {object} props 
 * @returns 
 */
const DropboxButton = (props) => {

  const dropboxButton = props.enable ? <a className="dropbox-saver" href={props.file}></a> : '';

  return (
    
      <React.StrictMode>
        {dropboxButton}
      </React.StrictMode>
    );
}

export {DriveButton, DropboxButton};